import { call, put, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { PUT } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import {
  UPDATE_CLIENT_DETAILS,
  UPDATE_CLIENT_DETAILS_SUCCESS,
  UPDATE_CLIENT_DETAILS_FAILURE,
  UpdateClientAction
} from 'src/redux/clientReducer'

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* UpdateClientDetailsFlow(action: UpdateClientAction): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const clientData = action.payload.data
    const endpoint = `/dealers_api/clients/${action.payload.id}`
    const response = yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: PUT,
      params: {
        client: {
          ...clientData
        }
      }
    })
    yield put(UPDATE_CLIENT_DETAILS_SUCCESS(response))
  } catch (error) {
    yield put(UPDATE_CLIENT_DETAILS_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* UpdateClientDetailsSaga(): Generator<any, void, any> {
  yield takeLatest(UPDATE_CLIENT_DETAILS, UpdateClientDetailsFlow)
}
